import { darkTheme, ThemeProvider } from '@sparemin/blockhead';
import React from 'react';
import useCustomFontsLoader from 'hooks/useCustomFontsLoader';

import { TextOverlayModalExtensions } from './extensions';
import TextOverlayProvider from './state/TextOverlayProvider';
import { TextOverlayLockedFeatures } from './state/types';
import TextOverlayModalView, {
  TextOverlayModalViewProps,
} from './TextOverlayModalView';
import { TextOverlayV2 } from './types';
import { DEFAULT_TEXT } from './utils';

export interface TextOverlayModalProps extends TextOverlayModalViewProps {
  defaultText?: string;
  extensions?: TextOverlayModalExtensions;
  lockedFeatures?: TextOverlayLockedFeatures;
  textOverlay?: TextOverlayV2;
  allowDynamicContent?: boolean;
}

const OVERLAY_Z_INDEX = 1050;

const TextOverlayModalContainer: React.FunctionComponent<TextOverlayModalProps> = props => {
  const {
    aspectRatio,
    defaultText = DEFAULT_TEXT,
    extensions = {},
    lockedFeatures,
    show,
    textOverlay,
    allowDynamicContent = false,
    ...rest
  } = props;

  useCustomFontsLoader();

  return (
    <ThemeProvider
      theme={{
        ...darkTheme,
        zIndex: {
          overlay: OVERLAY_Z_INDEX,
        },
      }}
    >
      <TextOverlayProvider
        aspectRatio={aspectRatio}
        defaultText={defaultText}
        extensions={extensions}
        lockedFeatures={lockedFeatures}
        show={show}
        textOverlay={textOverlay}
        allowDynamicContent={allowDynamicContent}
      >
        <TextOverlayModalView aspectRatio={aspectRatio} show={show} {...rest} />
      </TextOverlayProvider>
    </ThemeProvider>
  );
};

export default TextOverlayModalContainer;
